












































































































































































import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop, VModel } from 'vue-property-decorator'

import MiniHelpMessage from '../../components/MiniHelpMessage/MiniHelpMessage.vue'
import isTelegramWebview from '../../shared/utils/isTelegramWebview'
import { FileType, MediaFileData } from '../File/types'
import { MediaEditorMode } from "../NewMessageEditors/types";
import MediaUploader from './MediaUploader.vue'

@Component({
  components: {
    MiniHelpMessage,
    MediaUploader,
  },
  data() {
    return {
      FileType,
      snakeCase,
    }
  },
})
export default class UploadMediaModal extends Vue {
  @VModel() typeModalActive!: boolean

  @Prop({ type: Object }) mediaProps!: Record<string, any>

  @Prop({ type: Array }) filesData!: Array<MediaFileData>

  @Prop({ type: Array, default: () => [] }) blacklistMediaButtonTypes!:Array<FileType>

  @Prop({ type: Boolean, default: false }) disabled!:boolean

  @Emit('fileLoaded')
  fileLoaded(uploadedFile: MediaFileData): MediaFileData {
    this.typeModalActive = false

    return uploadedFile
  }

  @Emit('removeFile')
  removeFile(index: number): number {
    return index
  }

  currentStep: 'select' | 'upload' = 'select'

  selectedType: FileType | null = null

  get multipleUpload(): boolean {
    if (this.selectedType) {
      return ![ FileType.MessagePreview, FileType.TopMessagePreview, FileType.Voice, FileType.VideoNote, FileType.Animation ].includes(this.selectedType)
    }
    return true
  }

  get acceptedTypes(): string | null {
    if (!isTelegramWebview() && this.selectedType) {
      if ([ FileType.Video, FileType.VideoNote ].includes(this.selectedType)) {
        return 'video/*'
      }
      if ([ FileType.Audio, FileType.Voice ].includes(this.selectedType)) {
        return 'audio/*'
      }
      if (this.selectedType === FileType.Image) {
        return 'image/*'
      }

      return this.selectedType === FileType.MessagePreview || this.selectedType === FileType.TopMessagePreview ? 'image/*, video/*' : null
    }

    return null
  }

  get albumSupportButtonDisabled(): boolean {
    if (this.mediaProps.editorMode === MediaEditorMode.TelegramAll) {
      return false
    }
    return this.filesData.length > 0 && !this.filesData.some((uploadedFile) => [ FileType.Image, FileType.Video ].includes(uploadedFile.type))
  }

  get isUploadButtonsDisabled(): boolean {
    if (this.filesData.length >= 10) {
      return true
    }
    if (this.mediaProps.editorMode === MediaEditorMode.TelegramShort) {
      return this.filesData.length > 0
    }
    return false
  }

  isButtonAvailable(buttonType: FileType):boolean {
    if (this.blacklistMediaButtonTypes && this.blacklistMediaButtonTypes.length) {
      return !this.blacklistMediaButtonTypes.includes(buttonType)
    }

    return true
  }

  nonAlbumButtonDisabled(fileType: FileType): boolean {
    if (this.mediaProps.editorMode === MediaEditorMode.TelegramAll) {
      return false
    }

    const singleFileTypeInMessage = this.filesData.some((uploadFile) => [ FileType.VideoNote, FileType.Voice, FileType.TopMessagePreview, FileType.MessagePreview, FileType.Animation ].includes(uploadFile.type))
    return this.filesData.length > 0 && (!this.filesData.every((uploadFile) => uploadFile.type === fileType) || singleFileTypeInMessage)
  }

  onBackClick(): void {
    this.selectedType = null

    this.currentStep = 'select'
  }

  selectType(type: FileType): void {
    this.selectedType = type

    this.currentStep = 'upload'
  }
}
